import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Paper,
  Button,
  IconButton,
  Tooltip,
  Stack,
  useTheme,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  FormControlLabel,
  FormLabel,
  Grid,
} from "@mui/material";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import {
  explorePostData,
  fetchApidata,
  postApidata,
  postApidatawol,
  getDeployment,
  postDeployment,
  invoiceExploreGetData,
  postData,
  resetTrackingData,
  empAttendance,
  Attendance,
  AttendanceProcess,
  timeSheet,
  timeSheetPostData,
  timeSheetreport,
  resetTimeSheetAttendance,
} from "../../../store/reducers/Formapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  // DataGrid,
  GridToolbarContainer,
  // GridToolbarColumnsButton,
  // GridToolbarFilterButton,
  // GridToolbarExport,
  // GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Formik, Field } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { useProSidebar } from "react-pro-sidebar";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
//import TimeSheetPDF from "../pdf/TimeSheetPdf"
import TimeSheetPDF from "../../reports/TimeSheetPdf";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import store from "../../../index";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-hot-toast";
import {
  Employeeautocomplete,
  MultiFormikOptimizedAutocomplete,
  Productautocomplete,
} from "../../../ui-components/global/Autocomplete";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TimeSheetreportpdf from "../../reports/TimesheetReportpdf";
import { getConfig } from "../../../config";
import TimesheetReportExcel from "../../reports/TimesheetReportExcel";
import { FaFileExcel } from "react-icons/fa";



const Edittimesheetreport = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const mode = params.Mode;
  const dispatch = useDispatch();
  const isManager = sessionStorage.getItem("isManager");
  const EMPNAME = sessionStorage.getItem("EmpName");
  var recID = params.id;
  var accessID = params.accessID;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const listViewData = useSelector((state) => state.listviewApi.rowData);
  const listViewColumn = useSelector((state) => state.listviewApi.columnData);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  // const empAttendanceData = useSelector(
  //   (state) => state.formApi.empAttendanceData
  // );
  // console.log("empAttendanceData", empAttendanceData);
  const { Month, Year } = location.state || {};

  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const sliceSubscriptionCode = SubscriptionCode.slice(-3);
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");


  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);

  console.log(Month, "Received Month");
  console.log(Year, "Received Year");
  var QA = sessionStorage.getItem("qualityassurance");
  const [pageSize, setPageSize] = React.useState(14);
  const [page, setPage] = React.useState(0);
  const [isFiltered, setIsFiltered] = React.useState(false);
  const [rowCount, setRowCount] = React.useState(0);
  const [footerHeight, setFooterHeight] = useState(60);
  const [isReady, setIsReady] = useState(false);
  const AttendanceData = useSelector((state) => state.formApi.timeSheetData);
  const pdfEnabled = Array.isArray(AttendanceData) && AttendanceData.length > 0;
  const timeSheetLoading = useSelector((state) => state.formApi.timeSheetLoading);
  const projectName = useSelector((state) => state.formApi.projectName);
  const managerName = useSelector((state) => state.formApi.managerName);
  console.log("AttendanceData", AttendanceData);
  const CompanyID = sessionStorage.getItem("companyId");
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const data = useSelector((state) => state.formApi.Data);
  const isLoading = useSelector((state) => state.formApi.loading);
  // const [pageSize, setPageSize] = useState(10);
  // const [rowCount, setRowCount] = useState(0);
  const [show, setScreen] = React.useState("0");
  const EMPID = sessionStorage.getItem("EmpId");
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const colors = tokens(theme.palette.mode);
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  console.log(formattedDate);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [useCurrentEmp, setUseCurrentEmp] = useState(true);
  const [empData, setempData] = useState(null);
  const [selectedPro, setSelectedPro] = useState([]);
  const [selectedmiles, setSelectedMiles] = useState([]);
  const [selectedOS, setSelectedOS] = useState([]);
  const [selectedAct, setSelectedAct] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const milestoneID = selectedmiles.map((miles) => miles.RecordID).join(",");
  const OprStagID = selectedOS.map((opstg) => opstg.RecordID).join(",");
  const ActvitID = selectedAct.map((actsid) => actsid.RecordID).join(",");

  useEffect(() => {
    if (!FooterImg) return;

    const url = `${baseurl1}/uploads/images/${FooterImg}`;

    const img = new Image();
    img.src = url;

    img.onload = () => {
      const aspectRatio = img.height / img.width;

      // const pageWidth = 595;
      const pageWidth = 842;
      const MAX_FOOTER_HEIGHT = 80; // 🔥 IMPORTANT

      const calculatedHeight = Math.min(
        pageWidth * aspectRatio,
        MAX_FOOTER_HEIGHT
      );

      setFooterHeight(calculatedHeight);
      setIsReady(true);
    };
  }, [FooterImg]);
  useEffect(() => {
    dispatch(resetTrackingData());

    return () => {
      dispatch(resetTimeSheetAttendance());
    };
  }, [dispatch]);
  // useEffect(() => {
  //     fetch(process.env.PUBLIC_URL + "/validationcms.json")
  //         .then((res) => {
  //             if (!res.ok) throw new Error("Failed to fetch validationcms.json");
  //             return res.json();
  //         })
  //         .then((data) => {
  //             setErrorMsgData(data);
  //         })
  //         .catch((err) => console.error("Error loading validationcms.json:", err));
  // }, []);
  // useEffect(() => {
  //   const savedProData = sessionStorage.getItem("proData");
  //   const savedEmpData = sessionStorage.getItem("empData");
  //   const savedMileData = sessionStorage.getItem("selectedmiles");
  //   const savedOPData = sessionStorage.getItem("selectedOS");
  //   const savedActData = sessionStorage.getItem("selectedAct");
  //   // const savedSelf = sessionStorage.getItem("useCurrentEmp");
  //   const savedSelf = sessionStorage.getItem("useCurrentEmp") ?? "true";
  //   const savedFromDate = sessionStorage.getItem("FromDate");
  //   const savedToDate = sessionStorage.getItem("ToDate");
  //   const savedtasktype = sessionStorage.getItem("TR132_TaskType");

  //   const savedCheckboxes = {
  //     checkbox1: sessionStorage.getItem("checkbox1") === "true",
  //     checkbox2: sessionStorage.getItem("checkbox2") === "true",
  //     checkbox3: sessionStorage.getItem("checkbox3") === "true",
  //     checkbox4: sessionStorage.getItem("checkbox4") === "true",
  //     checkbox5: sessionStorage.getItem("checkbox5") === "true",
  //     checkbox6: sessionStorage.getItem("checkbox6") === "true",
  //     checkbox7: sessionStorage.getItem("checkbox7") === "true",
  //     checkbox8: sessionStorage.getItem("checkbox8") === "true",
  //   };

  //   const pro = savedProData ? JSON.parse(savedProData) : [];
  //   const miles = savedMileData ? JSON.parse(savedMileData) : [];
  //   const OP = savedOPData ? JSON.parse(savedOPData) : [];
  //   const Act = savedActData ? JSON.parse(savedActData) : [];
  //   const emp = savedEmpData ? JSON.parse(savedEmpData) : null;
  //   const self = savedSelf === "true" || false;
  //   const fromDate = savedFromDate || currentDate;
  //   const toDate = savedToDate || currentDate;
  //   const tasktype = savedtasktype ? JSON.parse(savedtasktype) : [];
  //   // Update local states
  //   setSelectedPro(pro);
  //   setSelectedMiles(miles);
  //   setSelectedOS(OP);
  //   setSelectedAct(Act);
  //   setempData(self ? null : emp);
  //   setUseCurrentEmp(self);

  //   const projectID = pro
  //     ? Array.isArray(pro)
  //       ? pro.map((p) => p.RecordID).join(",")
  //       : pro.RecordID
  //     : "";
  //   const employeeID = self ? EMPID : emp?.RecordID || "";

  //   // Build TaskSource and Status arrays
  //   const taskSourceArr = [];
  //   if (savedCheckboxes.checkbox1) taskSourceArr.push("S");
  //   if (savedCheckboxes.checkbox2) taskSourceArr.push("CR");
  //   if (savedCheckboxes.checkbox3) taskSourceArr.push("M");

  //   const statusArr = [];
  //   if (savedCheckboxes.checkbox4) statusArr.push("AS", "SH");
  //   if (savedCheckboxes.checkbox5) statusArr.push("SH");
  //   if (savedCheckboxes.checkbox6) statusArr.push("I");
  //   if (savedCheckboxes.checkbox7) statusArr.push("C");
  //   if (savedCheckboxes.checkbox8) statusArr.push("AP");

  //   // **Derive IDs from restored session data**
  //   const milestoneID =
  //     miles && miles.length ? miles.map((m) => m.RecordID).join(",") : 0;
  //   const OprStagID = OP && OP.length ? OP.map((o) => o.RecordID).join(",") : 0;
  //   const ActvitID =
  //     Act && Act.length ? Act.map((a) => a.RecordID).join(",") : 0;

  //   // Build AttendanceFilter string
  //   let attendanceFilter = `EmployeeID=${employeeID} AND ProjectID=${projectID} AND DaDate BETWEEN '${fromDate}' AND '${toDate}' AND CompanyID=${CompanyID} AND MilestonesID IN(${milestoneID}) AND OperationstageID IN(${OprStagID}) AND ActivityID IN(${ActvitID})`;

  //   if (taskSourceArr.length && statusArr.length) {
  //     attendanceFilter += ` AND (TaskSource IN(${taskSourceArr
  //       .map((v) => `'${v}'`)
  //       .join(",")}) AND Status IN(${statusArr
  //         .map((v) => `'${v}'`)
  //         .join(",")}))`;
  //   }
  //   //   if (tasktype) {
  //   //   attendanceFilter += ` AND TaskType IN (${tasktype
  //   //     .map(t => `'${t}'`)
  //   //     .join(",")})`;
  //   // }
  //   else if (taskSourceArr.length) {
  //     attendanceFilter += ` AND TaskSource IN(${taskSourceArr
  //       .map((v) => `'${v}'`)
  //       .join(",")})`;
  //   } else if (statusArr.length) {
  //     attendanceFilter += ` AND Status IN(${statusArr
  //       .map((v) => `'${v}'`)
  //       .join(",")})`;
  //   }
  //   if (tasktype.length > 0) {
  //     attendanceFilter += ` AND TaskType IN (${tasktype
  //       .map((t) => `'${t}'`)
  //       .join(",")})`;
  //   }
  //   dispatch(timeSheetreport({ data: { AttendanceFilter: attendanceFilter } }));
  //   setHasFetched(false);
  //   setSelectedPro([]);
  //   setSelectedAct([]);
  //   setSelectedOS
  //   setSelectedMiles
  // }, []);

  const queryObj = {
    Query: {
      AccessID: isManager === "1" ? "2119" : "2114",
      ScreenName: "Project",
      Filter: `parentID=${CompanyID} AND EmployeeID=${EMPID}`,
      Any: ""
    }
  };

  const projectID = selectedPro.map((proj) => proj.RecordID).join(",");

  const handleUnlock = async () => {
    const idata = {
      action: "update",
      DailyTaskRecordID: selectedRow?.RecordID,
      ApprovedBy: EMPID,
      ApprovedStatus: "",
      DateTime: formattedDate,
      Remarks: reason,
    };

    try {
      const response = await dispatch(timeSheetPostData({ idata }));

      if (response.payload.Status === "Y") {
        toast.success(response.payload.Msg);
        dispatch(timeSheet({ data: getData }));
        //handleDialogClose();
      } else {
        toast.error(response.payload.Msg);
      }
    } catch (error) {
      console.error("Error during timesheet post:", error);
      toast.error("Something went wrong!");
    }
  };
  // const handleFilterChange = (newFilterModel) => {
  //     setIsFiltered(newFilterModel.items?.some((item) => item.value));
  // };

  function AttendanceTool() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>List of Tasks</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }

  const AttColumn = [
    // {
    //     field: "serialNo",
    //     headerName: "SL#",
    //     width: 40,
    //     sortable: false,
    //     filterable: false,
    //     disableColumnMenu: true,
    //     renderCell: (params) => {
    //         return params.api.getRowIndex(params.id) + 1;
    //     },
    // },
    {
      field: "slno",
      headerName: "SL#",
      width: 60,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      headerAlign: "center",
      valueGetter: (params) => {
        const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
        const totalVisibleRows = params.api.getAllRowIds().length;
        const totalAllRows = params.api.getRowsCount();
        if (totalVisibleRows < totalAllRows) {
          return index + 1;
        } else {
          return page * pageSize + index + 1;
        }
      },
    },

    {
      field: "RecordID",
      headerName: "RecordID",
      headerAlign: "center",
      width: 80,
      hide: true,
    },
    {
      field: "Code",
      headerName: "Code",
      headerAlign: "center",
      width: 130,
      hide: true,
    },
    {
      field: "DTDate",
      headerName: "Date",
      headerAlign: "center",
      width: 130,
    },
    {
      field: "ProjectName",
      headerName: "Project",
      headerAlign: "center",
      width: 130,
    },

    {
      field: "Description",
      headerName: "Task",
      headerAlign: "center",
      width: 600,
      renderCell: (params) => {
        const description = params.row.Description || "";
        const comments = params.row.Comments || "";
        const combinedText = `${description} || ${comments}`;

        return (
          <Tooltip title={combinedText} placement="top-start" arrow>
            <div
              style={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {combinedText}
            </div>
          </Tooltip>
        );
      },
    },

    //    {
    //   field: "Description",
    //   headerName: "Description",
    //   width: 600,
    //   renderCell: (params) => {
    //     const description = params.row.Description || "";
    //     const comments = params.row.Comments || "";
    //     const combinedText = `${description} || ${comments}`;

    //     return (
    //       <div
    //         style={{
    //           width: "100%",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //           whiteSpace: "nowrap",
    //         }}
    //         title={combinedText}
    //       >
    //         {combinedText}
    //       </div>
    //     );
    //   },
    // },

    {
      field: "ProjectCode",
      headerName: "ProjectCode",
      width: 130,
      hide: true,
    },
    {
      field: "EmpStatus",
      headerName: "Status",
      headerAlign: "center",
      width: 120,
    },
    {
      field: "DailytaskSource",
      headerName: "Source",
      headerAlign: "center",
      width: 100,
    },
  ];

  const safeAttendanceData = Array.isArray(AttendanceData)
    ? AttendanceData
    : [];
  console.log(safeAttendanceData, "safeAttendanceData");
  // Then:
  const ApprovedData = safeAttendanceData.filter(
    (row) => row.ApprovedStatus === "A",
  );
  console.log(ApprovedData, "===ApprovedData");
  /***********Attendance ************/

  const currentMonthNumber = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  // const AttInitialvalues = {
  //     checkbox1: true,
  //     checkbox5: true,
  //     checkbox2: false,
  //     checkbox3: false,
  //     checkbox4: false,
  //     checkbox6: false,
  //     checkbox7: false,
  //     checkbox8: false,
  // };
  // const today = new Date();
  // const currentMonth = today.getMonth() + 1;
  // const currentYear = today.getFullYear();
  const currentDate = today.toISOString().split("T")[0];

  // const AttInitialvalues = {
  //   FromDate: sessionStorage.getItem("FromDate") || currentDate,
  //   ToDate: sessionStorage.getItem("ToDate") || currentDate,
  //   ProName: sessionStorage.getItem("proData")
  //     ? JSON.parse(sessionStorage.getItem("proData"))
  //     : [],
  //   Employee: sessionStorage.getItem("empData")
  //     ? JSON.parse(sessionStorage.getItem("empData"))
  //     : null,

  //   useCurrentEmp: sessionStorage.getItem("useCurrentEmp") === "true" || true,
  //   checkbox1: sessionStorage.getItem("checkbox1") === "true" || false,
  //   checkbox2: sessionStorage.getItem("checkbox2") === "true" || false,
  //   checkbox3: sessionStorage.getItem("checkbox3") === "true" || false,
  //   checkbox4: sessionStorage.getItem("checkbox4") === "true" || false,
  //   checkbox5: sessionStorage.getItem("checkbox5") === "true" || false,
  //   checkbox6: sessionStorage.getItem("checkbox6") === "true" || false,
  //   checkbox7: sessionStorage.getItem("checkbox7") === "true" || false,
  //   checkbox8: sessionStorage.getItem("checkbox8") === "true" || false,
  //   TaskType: JSON.parse(sessionStorage.getItem("TR132_TaskType") || "[]"),
  // };
  const AttInitialvalues = {
    FromDate: currentDate,
    ToDate: currentDate,
    // ProName: [],
    ProName: null,
    Employee: null,

    useCurrentEmp: true,
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    checkbox4: false,
    checkbox5: false,
    checkbox6: false,
    checkbox7: false,
    checkbox8: false,
    TaskType: [],
  };

  const [getData, setData] = useState("");

  // const attendaceFnSave = async (values) => {

  //     const statusMapping = {
  //       checkbox1: 'S',
  //       checkbox2: 'MT',
  //       checkbox3: 'SH',
  //       checkbox5: 'AP',
  //       checkbox6: 'RJ'
  //     };

  //     let statusValues = [];

  //     if (values.checkbox4) {
  //       statusValues.push('N', 'SH', 'A');
  //     }

  //     for (const [key, label] of Object.entries(statusMapping)) {
  //       if (values[key]) {
  //         statusValues.push(label);
  //       }

  //     }

  //     const AttendanceFilter = `EmployeeID=${useCurrentEmp ? EMPID : empData.RecordID} AND ProjectID IN(${projecID}) AND Status IN(${statusValues.map(val => `'${val}'`).join(',')})`;

  //     const data = {
  //         AttendanceFilter
  //     };

  //     setData(data);
  //     dispatch(timeSheetreport({ data }));
  //   };

  const attendaceFnSave = async (values) => {
    const statusMapping = {
      checkbox1: "S", // TaskSource
      checkbox2: "CR", // TaskSource
      checkbox3: "M", // TaskSource
      checkbox5: "SH", // Status
      checkbox6: "I", // Status
      checkbox7: "C",
      checkbox8: "AP",
    };

    let taskSourceValues = [];
    let statusValues = [];

    // Group 1: TaskSource (checkbox1-3)
    if (values.checkbox1) taskSourceValues.push("S");
    if (values.checkbox2) statusValues.push("CR");
    if (values.checkbox3) taskSourceValues.push("M");

    // Group 2: Status (checkbox4-6)
    // if (values.checkbox4) statusValues.push('N', 'SH', 'A'); // special handling for checkbox4
    if (values.checkbox4) statusValues.push("AS", "SH");
    if (values.checkbox5) statusValues.push("SH");
    if (values.checkbox6) statusValues.push("I");
    if (values.checkbox7) statusValues.push("C");
    if (values.checkbox8) statusValues.push("AP");

    //  let AttendanceFilter = `EmployeeID=${useCurrentEmp ? EMPID : empData.RecordID} AND ProjectID IN(${projecID})`;
    let AttendanceFilter = `EmployeeID=${useCurrentEmp ? EMPID : empData.RecordID
      // } AND ProjectID=${projecID} AND DaDate BETWEEN '${values.FromDate}' AND '${values.ToDate
      } AND ProjectID IN (${projecID}) AND DaDate BETWEEN '${values.FromDate}' AND '${values.ToDate
      }' AND CompanyID=${CompanyID} AND MilestonesID=${milestoneID || 0
      } AND OperationstageID=${OprStagID || 0} AND ActivityID=${ActvitID || 0}`;

    if (taskSourceValues.length > 0 && statusValues.length === 0) {
      AttendanceFilter += ` AND TaskSource IN(${taskSourceValues
        .map((val) => `'${val}'`)
        .join(",")})`;
    } else if (statusValues.length > 0 && taskSourceValues.length === 0) {
      AttendanceFilter += ` AND Status IN(${statusValues
        .map((val) => `'${val}'`)
        .join(",")})`;
    } else if (taskSourceValues.length > 0 && statusValues.length > 0) {
      AttendanceFilter += ` AND (TaskSource IN(${taskSourceValues
        .map((val) => `'${val}'`)
        .join(",")}) AND Status IN(${statusValues
          .map((val) => `'${val}'`)
          .join(",")}))`;
    }
    if (values.TaskType && values.TaskType.length > 0) {
      AttendanceFilter += ` AND TaskType IN (${values.TaskType.map(
        (t) => `'${t}'`,
      ).join(",")})`;
    }

    const data = { AttendanceFilter };
    setData(data);
    dispatch(timeSheetreport({ data }));
    setHasFetched(true);
  };

  console.log(getData, "---------------------GETDATA");

  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData,
  );
  const explorelistViewColumn = useSelector(
    (state) => state.exploreApi.explorecolumnData,
  );
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const screenChange = (event) => {
    setScreen(event.target.value);
  };
  const VISIBLE_FIELDS = [
    "SLNO",
    "OtDate",
    "NumberOfHours",
    "Status",
    "action",
  ];
  const [funMode, setFunMode] = useState("A");
  const columns = React.useMemo(
    () =>
      explorelistViewColumn
        ? explorelistViewColumn.filter((column) =>
          VISIBLE_FIELDS.includes(column.field),
        )
        : [],
    [explorelistViewColumn],
  );
  const handlePagechange = (pageno) => {
    setPage(pageno);
    sessionStorage.setItem("currentPage", pageno);
  };
  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate(-1);
      }
    });
  };
  const handleSelectionEmployeeChange = (newValue) => {
    if (newValue) {
      setempData(newValue);
      console.log(newValue.RecordID, "--selectedproductid");
    } else {
      setempData(null);
    }
    setUseCurrentEmp(false);
  };
  const [open, setOpen] = React.useState(false);

  const [reason, setReason] = useState("");
  const projecID = selectedPro.map((ProName) => ProName.RecordID).join(",");
  return (
    <React.Fragment>
      {/* {getLoading && <LinearProgress />} */}
      <Paper
        elevation={3}
        sx={{ margin: "0px 10px", background: "#F2F0F0", height: "40px" }}
      >
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Typography
              variant="h4"
              sx={{ fontsize: "19px", marginLeft: "10px",color:"#0000D1"}}
            >
              Timesheet Report ({useCurrentEmp ? EMPNAME : empData?.Name ?? EMPNAME})
            </Typography>
          </Box>
          <Box display="flex">
            {/* <Tooltip title="Attendance ">
            <IconButton
              onClick={() => navigate("/Apps/TR217/Attendance")}
              color="primary"
            >
              <ListAltOutlinedIcon />
            </IconButton>
          </Tooltip> */}
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>


      <Paper elevation={3} sx={{ margin: "10px" }}>
        {/* <Box m="10px"> */}
        <Formik
          initialValues={AttInitialvalues}
          enableReinitialize={true}
          onSubmit={(values, { resetForm }) => {
            setTimeout(() => {
              attendaceFnSave(values, resetForm);
            }, 100);
          }}
        >
          {({
            errors,
            touched,
            handleBlur,
            handleChange,
            isSubmitting,
            values,
            handleSubmit,
            resetForm,
            setFieldValue,
          }) => (
            <form
              onSubmit={handleSubmit}
              onReset={() => {
                resetForm();
                // setUseCurrentEmp(false);
                setSelectedPro([]);
                setSelectedMiles([]);
                setSelectedOS([]);
                setSelectedAct([]);
                setempData(null);
                sessionStorage.removeItem("proData");
                sessionStorage.removeItem("selectedmiles");
                sessionStorage.removeItem("selectedOS");
                sessionStorage.removeItem("selectedAct");
                sessionStorage.removeItem("empData");
                sessionStorage.removeItem("FromDate");
                sessionStorage.removeItem("TR132_TaskType");
                sessionStorage.removeItem("ToDate");
                sessionStorage.removeItem("checkbox1");
                sessionStorage.removeItem("checkbox2");
                sessionStorage.removeItem("checkbox3");
                sessionStorage.removeItem("checkbox4");
                sessionStorage.removeItem("checkbox5");
                sessionStorage.removeItem("checkbox6");
                sessionStorage.removeItem("checkbox7");
                sessionStorage.removeItem("checkbox8");
                // sessionStorage.removeItem("useCurrentEmp");
                dispatch(resetTrackingData());
                setUseCurrentEmp(true);
                sessionStorage.setItem("useCurrentEmp", "true");
              }}
            >
              <Box
                display="grid"
                gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                gap={formGap}
                padding={1}
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 4",
                  },
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  gap={2}
                  sx={{ flexWrap: "wrap", gridColumn: "span 2" }}
                >
                  <Box sx={{ minWidth: 250 }}>
                    {/* <MultiFormikOptimizedAutocomplete
                                            sx={{ width: "100%" }}
                                            name="ProName"
                                            label="Project"
                                            id="ProName"
                                            value={selectedPro}
                                            onChange={(e, newValue) => {
                                                setFieldValue("block", newValue);
                                                setSelectedPro(newValue);
                                            }}
                                            url={`${listViewurl}?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID=${companyID}","Any":""}}`}
                                        /> */}
                    <MultiFormikOptimizedAutocomplete
                      sx={{ width: "100%" }}
                      name="ProName"
                      label={is003Subscription ? "Standard" : "Project"}
                      id="ProName"
                      value={selectedPro}
                      onChange={(e, newValue) => {
                        setFieldValue("ProName", newValue); // Update Formik value
                        setSelectedPro(newValue); // Update local state
                        if (newValue) {
                          sessionStorage.setItem(
                            "proData",
                            JSON.stringify(newValue),
                          ); // Save to session
                        } else {
                          sessionStorage.removeItem("proData"); // Remove from session if cleared
                        }
                      }}
                      // url={`${listViewurl}?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID=${CompanyID}","Any":""}}`}
                      // url={`${listViewurl}?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID=${CompanyID}","Any":"","VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`}
                      // url={`${listViewurl}?data={"Query":{"AccessID":"2119","ScreenName":"Project","Filter":"parentID=${CompanyID} AND EmployeeID=${EMPID}","Any":"","VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`}
                      //CHANGED ON 04/05/2026 -- AS FOR EMPLOYEE 2114 LOOKUP IS REQUIRED -- BY MANOJ
                      url={`${listViewurl}?data=${JSON.stringify(queryObj)}`}
                    />
                  </Box>
                  {isManager == 1 && (
                    <Employeeautocomplete
                      sx={{ width: 230 }}
                      name="Employee"
                      label="Personnel"
                      id="Employee"
                      value={empData}
                      onChange={(newValue) => {
                        setempData(newValue);
                        if (newValue)
                          sessionStorage.setItem(
                            "empData",
                            JSON.stringify(newValue),
                          );
                        else sessionStorage.removeItem("empData");
                        setUseCurrentEmp(false);
                      }}
                      error={!!touched.empName && !!errors.empName}
                      helperText={touched.empName && errors.empName}
                      url={
                        QA === "Y"
                          // ? `${listViewurl}?data={"Query":{"AccessID":"2118","ScreenName":"EMPLOYEETEAMS","Filter":"ProjectID=${projecID} AND EmpID NOT IN (${EMPID}) GROUP BY RecordID","Any":"","CompId":${CompanyID}}}`
                          ? `${listViewurl}?data={"Query":{"AccessID":"2118","ScreenName":"EMPLOYEETEAMS","Filter":"ProjectID=${projecID} AND EmpID NOT IN (${EMPID}) GROUP BY RecordID","Any":"","CompId":${CompanyID},"VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`
                          // : `${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${CompanyID}}}`
                          //POINT BY NK -->CHANGED ON 04/04/2026 - ACCESS --> 2162 --> PERSONNEL WILL BE CHOSEN UPON MANAGERID AND PROJECTID IN TIMESHEET EMPLOYEES SCREEN
                          // : `${listViewurl}?data={"Query":{"AccessID":"2162","ScreenName":"TIMESHEETEMP","Filter":"parentID='${EMPID}' AND DefaultProjectID='${projecID}'","Any":"","CompId":${CompanyID}}}`
                          : `${listViewurl}?data={"Query":{"AccessID":"2162","ScreenName":"TIMESHEETEMP","Filter":"parentID='${EMPID}' AND DefaultProjectID='${projecID}'","Any":"","CompId":${CompanyID},"VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`


                      }
                    />
                  )}

                  <TextField
                    name="FromDate"
                    size="small"
                    type="date"
                    id="FromDate"
                    label="From Date"
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                    focused
                    value={values.FromDate}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      sessionStorage.setItem("FromDate", e.target.value);
                    }}
                    error={!!touched.FromDate && !!errors.FromDate}
                    helperText={touched.FromDate && errors.FromDate}
                    sx={{ width: 200 }}
                  />

                  <TextField
                    name="ToDate"
                    size="small"
                    type="date"
                    id="ToDate"
                    label="To Date"
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                    focused
                    value={values.ToDate}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      sessionStorage.setItem("ToDate", e.target.value);
                    }}
                    error={!!touched.ToDate && !!errors.ToDate}
                    helperText={touched.ToDate && errors.ToDate}
                    sx={{ width: 200 }}
                    inputProps={{
                      min:
                        values.FromDate ||
                        new Date().toISOString().split("T")[0],
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={useCurrentEmp}
                        onChange={(e) => {
                          setUseCurrentEmp(e.target.checked);
                          setempData(null);
                          sessionStorage.setItem(
                            "useCurrentEmp",
                            e.target.checked,
                          );
                        }}
                        color="primary"
                      />
                    }
                    label="Self"
                    sx={{ marginLeft: 2 }}
                  />
                </Box>
                <Box sx={{ marginTop: "3px" }}>
                  <MultiFormikOptimizedAutocomplete
                    sx={{
                      marginTop: "7px",
                      width: {
                        xs: "auto", // < 600px (mobile)
                        sm: "350px", // >= 600px
                        md: "400px", // >= 900px (optional)
                        lg: "500px", // >= 1200px (optional)
                      },
                    }}
                    name="Milestone"
                    label={is003Subscription ? "Section" : "Milestone"}
                    variant="outlined"
                    id="Milestone"
                    value={selectedmiles}
                    getOptionLabel={(option) => option?.Name || ""}
                    onChange={(e, newValue) => {
                      setFieldValue("Milestone", newValue);
                      setSelectedMiles(newValue);
                      //Lookup Clear
                      if (newValue)
                        sessionStorage.setItem(
                          "selectedmiles",
                          JSON.stringify(newValue),
                        );
                      else sessionStorage.removeItem("selectedmiles");
                      if (!newValue || newValue.length === 0) {
                        setSelectedOS([]);
                        setSelectedAct([]);
                        setFieldValue("OperationStage", []);
                        setFieldValue("Activities", []);
                      }
                    }}
                    // url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID='${selectedPro ? selectedPro.RecordID : 0}'","Any":""}}`}
                    // url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID IN(${projectID}) AND CompanyID='${CompanyID}'","Any":""}}`}
                    url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID IN(${projectID}) AND CompanyID='${CompanyID}'","Any":"","VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`}
                  />
                  <MultiFormikOptimizedAutocomplete
                    sx={{
                      marginTop: "7px",
                      width: {
                        xs: "auto", // < 600px (mobile)
                        sm: "350px", // >= 600px
                        md: "400px", // >= 900px (optional)
                        lg: "500px", // >= 1200px (optional)
                      },
                      //width: 500
                    }}
                    name="OperationStage"
                    label="Operation Stage"
                    variant="outlined"
                    id="OperationStage"
                    value={selectedOS}
                    onChange={(e, newValue) => {
                      setFieldValue("OperationStage", newValue);
                      setSelectedOS(newValue);
                      if (newValue)
                        sessionStorage.setItem(
                          "selectedOS",
                          JSON.stringify(newValue),
                        );
                      else sessionStorage.removeItem("selectedOS");
                      if (!newValue || newValue.length === 0) {
                        setSelectedAct([]);
                        setFieldValue("Activities", []);
                      }
                    }}
                    // url={`${listViewurl}?data={"Query":{"AccessID":"2104","ScreenName":"Operation Stage","Filter":"parentID IN(${milestoneID})","Any":""}}`}
                    url={`${listViewurl}?data={"Query":{"AccessID":"2104","ScreenName":"Operation Stage","Filter":"parentID IN(${milestoneID})","Any":"","VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`}
                  />

                  <MultiFormikOptimizedAutocomplete
                    sx={{
                      marginTop: "7px",
                      //width: 500
                      width: {
                        xs: "auto", // < 600px (mobile)
                        sm: "350px", // >= 600px
                        md: "400px", // >= 900px (optional)
                        lg: "500px", // >= 1200px (optional)
                      },
                    }}
                    name="Activities"
                    label="Activities"
                    variant="outlined"
                    id="Activities"
                    value={selectedAct}
                    onChange={(e, newValue) => {
                      setFieldValue("Activities", newValue);
                      setSelectedAct(newValue);
                      if (newValue)
                        sessionStorage.setItem(
                          "selectedAct",
                          JSON.stringify(newValue),
                        );
                      else sessionStorage.removeItem("selectedAct");
                      console.log(newValue, "-- setSelectedAct newValue");
                    }}
                    url={`${listViewurl}?data={"Query":{"AccessID":"2103","ScreenName":"Activities","Filter":"parentID IN(${OprStagID})","Any":"","VerticalLicense":"${is003Subscription ? sliceSubscriptionCode : ""}"}}`}
                  />
                  <FormControl
                    variant="standard"
                    sx={{
                      mt: 1,
                      width: {
                        xs: "100%",
                        sm: "350px",
                        md: "400px",
                        lg: "500px",
                      },
                    }}
                    focused
                  >
                    <InputLabel id="TaskType-label">Task Type</InputLabel>

                    <Select
                      fullWidth
                      labelId="TaskType-label"
                      id="TaskType"
                      name="TaskType"
                      multiple
                      value={
                        Array.isArray(values.TaskType) ? values.TaskType : []
                      }
                      onChange={(e) => {
                        const selectedValues = e.target.value;
                        handleChange({
                          target: {
                            name: "TaskType",
                            value: selectedValues,
                          },
                        });
                        sessionStorage.setItem(
                          "TR132_TaskType",
                          JSON.stringify(selectedValues),
                        );
                      }}
                      onBlur={handleBlur}
                      renderValue={(selected) => selected.join(", ")}
                    >
                      <MenuItem value="Normal">Normal</MenuItem>
                      <MenuItem value="Learning&development">
                        Learning & development
                      </MenuItem>
                      <MenuItem value="Research&development">
                        Research & development
                      </MenuItem>
                      <MenuItem value="Up-skill">Up-skill</MenuItem>
                      <MenuItem value="Bug">Bug</MenuItem>
                      <MenuItem value="Improvements">Improvements</MenuItem>
                      <MenuItem value="Minutes of Meeting">
                        Minutes of Meeting
                      </MenuItem>
                      <MenuItem value="Script">Script</MenuItem>
                      <MenuItem value="Documentation">Documentation</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                <FormControl fullWidth sx={{ gridColumn: "span 1" }}>
                  <Box
                    sx={{
                      paddingX: 3,
                      paddingY: 2,
                      marginBottom: 3,
                      marginTop: -1,
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={8}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} sm={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.checkbox1}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "checkbox1",
                                      e.target.checked,
                                    ); // update Formik
                                    sessionStorage.setItem(
                                      "checkbox1",
                                      e.target.checked,
                                    ); // save session
                                  }}
                                />
                              }
                              label="Self Task"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.checkbox2}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "checkbox2",
                                      e.target.checked,
                                    ); // update Formik
                                    sessionStorage.setItem(
                                      "checkbox2",
                                      e.target.checked,
                                    ); // save session
                                  }}
                                />
                              }
                              label="Created"
                            />
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.checkbox3}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "checkbox3",
                                      e.target.checked,
                                    ); // update Formik
                                    sessionStorage.setItem(
                                      "checkbox3",
                                      e.target.checked,
                                    ); // save session
                                  }}
                                />
                              }
                              label="Manager Assigned Task"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.checkbox4}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "checkbox4",
                                      e.target.checked,
                                    ); // update Formik
                                    sessionStorage.setItem(
                                      "checkbox4",
                                      e.target.checked,
                                    ); // save session
                                  }}
                                />
                              }
                              label="Backlog"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.checkbox5}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "checkbox5",
                                      e.target.checked,
                                    ); // update Formik
                                    sessionStorage.setItem(
                                      "checkbox5",
                                      e.target.checked,
                                    ); // save session
                                  }}
                                />
                              }
                              label="Scheduled Task"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.checkbox6}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "checkbox6",
                                      e.target.checked,
                                    ); // update Formik
                                    sessionStorage.setItem(
                                      "checkbox6",
                                      e.target.checked,
                                    ); // save session
                                  }}
                                />
                              }
                              label="Inprogress"
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Grid container spacing={1} direction="column">
                          <Grid item>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.checkbox7}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "checkbox7",
                                      e.target.checked,
                                    ); // update Formik
                                    sessionStorage.setItem(
                                      "checkbox7",
                                      e.target.checked,
                                    ); // save session
                                  }}
                                />
                              }
                              label="Completed"
                            />
                          </Grid>
                          <Grid item>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.checkbox8}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "checkbox8",
                                      e.target.checked,
                                    ); // update Formik
                                    sessionStorage.setItem(
                                      "checkbox8",
                                      e.target.checked,
                                    ); // save session
                                  }}
                                />
                              }
                              label="Approved"
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Box>
                </FormControl>
              </Box>

              <Box
                mt={-2}
                display="flex"
                justifyContent="end"
                padding={1}
                gap={formGap}
              >
                <Button type="submit" variant="contained" color="secondary">
                  APPLY
                </Button>
                <Button type="reset" variant="contained" color="error">
                  RESET
                </Button>
                <Button
                  color="warning"
                  variant="contained"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  Cancel
                </Button>
                {pdfEnabled ? (
                  <PDFDownloadLink
                    document={
                      // <TimeSheetreportpdf
                      //     data={safeAttendanceData}
                      //     filters={{
                      //         Month: Month,
                      //         Year: Year,
                      //         EmployeeID: empData?.Name || EMPNAME,
                      //     }}
                      // />
                      <TimeSheetreportpdf
                        data={safeAttendanceData}
                        projectName={projectName}
                        managerName={managerName}
                        filters={{
                          Month: Month,
                          Year: Year,
                          EmployeeID: empData?.Name || EMPNAME,
                          Imageurl: baseurl1,
                          HeaderImg: HeaderImg,
                          FooterImg: FooterImg,
                        }}
                        footerHeight={footerHeight}

                      />
                    }
                    fileName={`TimeSheet_Report_${empData?.Name || "Personnel"
                      }.pdf`}
                    style={{ color: "#d32f2f", cursor: "pointer" }} // Red for PDF feel
                  >
                    {({ loading }) =>
                      loading ? (
                        <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
                      ) : (
                        <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                      )
                    }
                  </PDFDownloadLink>
                ) : (<PictureAsPdfIcon
                  sx={{
                    fontSize: 24,
                    opacity: 0.3,
                    cursor: "not-allowed",
                    pointerEvents: "none",
                  }}
                />)}
                <FaFileExcel
                  size={20}
                  color="#1D6F42"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    TimesheetReportExcel(
                      safeAttendanceData,
                      {
                        Month: Month,
                        Year: Year,
                        EmployeeID: empData?.Name || EMPNAME,
                      },
                      projectName,
                      managerName,
                    )
                  }
                />
              </Box>

              {hasFetched && (
                <Box sx={{ gridColumn: "span 4" }}>
                  <Box
                    height="450px"
                    // height={dataGridHeight}
                    //marginTop={2}
                    sx={{
                      "& .MuiDataGrid-root": {
                        // border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        // borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        // borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        // borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#d0edec",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    {/* <DataGrid
                                        sx={{
                                            "& .MuiDataGrid-footerContainer": {
                                                height: dataGridHeaderFooterHeight,
                                                minHeight: dataGridHeaderFooterHeight,
                                            }
                                        }}
                                        rowHeight={dataGridRowHeight}
                                        headerHeight={dataGridHeaderFooterHeight}
                                        rows={AttendanceData}
                                        columns={AttColumn}
                                        disableSelectionOnClick
                                        getRowId={(row) => row.RecordID}
                                        pageSize={pageSize}

                                        onPageSizeChange={(newPageSize) =>
                                            setPageSize(newPageSize)
                                        }
                                        onCellClick={(params) => { }}
                                        rowsPerPageOptions={[5, 10, 20]}
                                        pagination
                                        components={{
                                            Toolbar: AttendanceTool,
                                        }}
                                        onStateChange={(stateParams) =>
                                            setRowCount(stateParams.pagination.rowCount)
                                        }
                                        loading={exploreLoading}
                                        componentsProps={{
                                            toolbar: {
                                                showQuickFilter: true,
                                                quickFilterProps: { debounceMs: 500 },
                                            },
                                        }}

                                        getRowClassName={(params) =>
                                            params.indexRelativeToCurrentPage % 2 === 0
                                                ? 'odd-row'
                                                : 'even-row'
                                        }
                                    /> */}
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      rows={AttendanceData}
                      columns={AttColumn}
                      disableSelectionOnClick
                      getRowId={(row) => row.RecordID}
                      pageSize={pageSize}
                      page={page}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      onPageChange={(newPage) => setPage(newPage)}
                      rowsPerPageOptions={[5, 10, 20]}
                      pagination
                      components={{ Toolbar: AttendanceTool }}
                      onStateChange={(stateParams) =>
                        setRowCount(stateParams.pagination.rowCount)
                      }
                      // onFilterModelChange={handleFilterChange}
                      loading={timeSheetLoading}
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                    />
                  </Box>
                </Box>
              )}
            </form>
          )}
        </Formik>
        {/* </Box> */}
      </Paper>

    </React.Fragment>
  );
};

export default Edittimesheetreport;
